/*
  src/redux/version/constants.js

  Created by erikchristensen on 11/03/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

function createConstant(action){
  return ['portal', 'version', action].join('/');
}


export const VERSION_REQUESTED = createConstant('VERSION_REQUESTED');
export const VERSION_LOADED = createConstant('VERSION_LOADED');
export const VERSION_FAILED_TO_LOAD = createConstant('VERSION_FAILED_TO_LOAD');



// WEBPACK FOOTER //
// ./src/shared/redux/version/constants.js